/*
  Kalessie - Collection filter chips (client-side, no reload). Mirrors the
  prototype (Kalessie Collection Page.html): pills filter the loaded grid by
  material / badge / sale / stock using data-* attributes on each .kal-card.
  Re-applies after "Load more" appends new cards (kal:grid-appended event).
*/
(function () {
  // data-mat is a list, not a single value: a piece offered in both metals
  // must answer to both chips.
  function hasMat(card, metal) {
    return (card.dataset.mat || '').split(/\s+/).indexOf(metal) !== -1;
  }

  function matches(card, filter) {
    switch (filter) {
      case 'all': return true;
      case 'gold': return hasMat(card, 'gold');
      case 'silver': return hasMat(card, 'silver');
      case 'new': return card.dataset.new === 'true';
      case 'sale': return card.dataset.sale === 'true';
      case 'instock': return card.dataset.instock === 'true';
      default: return true;
    }
  }

  function apply(bar) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var filter = bar.getAttribute('data-active') || 'all';
    var shown = 0;
    grid.querySelectorAll('.kal-card').forEach(function (card) {
      var item = card.closest('.grid__item') || card;
      var ok = matches(card, filter);
      item.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    var empty = document.querySelector('[data-kal-filter-empty]');
    if (empty) empty.hidden = shown !== 0;
  }

  // The chips filter the cards already in the grid, so on a paginated
  // collection they would only ever search page one — "925 Silver" would
  // report a handful when the catalogue holds far more. Narrowing therefore
  // pulls in the remaining pages first, one Load more at a time.
  function loadEverything(done) {
    var btn = document.querySelector('[data-kal-load-more]');
    if (!btn || !btn.getAttribute('data-next-url')) { done(); return; }
    var guard = 0;
    (function step() {
      var live = document.querySelector('[data-kal-load-more]');
      if (!live || !live.getAttribute('data-next-url') || ++guard > 40) { done(); return; }
      live.click();
      // kal-load-more swaps the button's next-url when the fetch resolves.
      var waited = 0;
      (function poll() {
        var b = document.querySelector('[data-kal-load-more]');
        if (!b || b.getAttribute('aria-busy') !== 'true' || ++waited > 100) { step(); return; }
        setTimeout(poll, 60);
      })();
    })();
  }

  function init(bar) {
    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (!chip) return;
      bar.querySelectorAll('[data-filter]').forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var filter = chip.getAttribute('data-filter');
      bar.setAttribute('data-active', filter);
      apply(bar);
      if (filter !== 'all') loadEverything(function () { apply(bar); });
    });
    // Re-apply the active filter to cards appended by Load more.
    document.addEventListener('kal:grid-appended', function () { apply(bar); });
  }

  document.querySelectorAll('[data-kal-filter-bar]').forEach(init);
})();
